export const eventData = {
  headerClick: 'header_click',
  headerStocksClick: 'header_stocks_click',
  headerInvestClick: 'header_invest_click',
  headerUsstocksClick: 'header_usstocks_click',
  headerEtfsClick: 'header_etfs_click',
  headerMutualfundsClick: 'header_mutualfunds_click',
  headerNpsClick: 'header_nps_click',
  headerOtherinstrumentsClick: 'header_otherinstruments_click',
  headerCalculatorClick: 'header_calculator_click',
  headerFeaturesClick: 'header_features_click',
  headerMarketmoversClick: 'header_marketmovers_click',
  headerMarketsClick: 'header_markets_click',
  headerStockcategoryClick: 'header_stockcategory_click',
  headerIndicesClick: 'header_indices_click',
  headerGlobalindicesClick: 'header_globalindices_click',
  headerDisclosureClick: 'header_disclosure_click',
  headerHelpCenterIconClick: 'header_helpcenter_icon_click',
  headerLoginSignupCtaClick: 'header_loginsignup_cta_click',
  headerHamburgerClick: 'header_hamburger_click',
  headerSearchClick: 'header_search_click',
  headerCreatedematButtonClick: 'header_createdemat_button_click',
  headerDownloadBannerClick: 'header_download_banner_click',
  headerCrossButtonClick: 'header_cross_button_click',
  headerLoginCtaClick: 'header_login_cta_click',
  headerSignupCtaClick: 'header_signup_cta_click',
}

export const eventMapping = {
  [eventData.headerClick]: {
    event: 'header_click',
    eventCategory: 'header_click',
  },
  [eventData.headerStocksClick]: {
    event: 'header_stocks_click',
    eventCategory: 'header_click',
  },
  [eventData.headerInvestClick]: {
    event: 'header_invest_click',
    eventCategory: 'header_click',
  },
  [eventData.headerUsstocksClick]: {
    event: 'header_usstocks_click',
    eventCategory: 'header_click',
  },
  [eventData.headerEtfsClick]: {
    event: 'header_etfs_click',
    eventCategory: 'header_click',
  },
  [eventData.headerMutualfundsClick]: {
    event: 'header_mutualfunds_click',
    eventCategory: 'header_click',
  },
  [eventData.headerNpsClick]: {
    event: 'header_nps_click',
    eventCategory: 'header_click',
  },
  [eventData.headerOtherinstrumentsClick]: {
    event: 'header_otherinstruments_click',
    eventCategory: 'header_click',
  },
  [eventData.headerCalculatorClick]: {
    event: 'header_calculator_click',
    eventCategory: 'header_click',
  },
  [eventData.headerFeaturesClick]: {
    event: 'header_features_click',
    eventCategory: 'header_click',
  },
  [eventData.headerMarketmoversClick]: {
    event: 'header_marketmovers_click',
    eventCategory: 'header_click',
  },
  [eventData.headerMarketsClick]: {
    event: 'header_markets_click',
    eventCategory: 'header_click',
  },
  [eventData.headerStockcategoryClick]: {
    event: 'header_stockcategory_click',
    eventCategory: 'header_click',
  },
  [eventData.headerIndicesClick]: {
    event: 'header_indices_click',
    eventCategory: 'header_click',
  },
  [eventData.headerGlobalindicesClick]: {
    event: 'header_globalindices_click',
    eventCategory: 'header_click',
  },
  [eventData.headerDisclosureClick]: {
    event: 'header_disclosure_click',
    eventCategory: 'header_click',
  },
  [eventData.headerHelpCenterIconClick]: {
    event: 'header_helpcenter_icon_click',
    eventCategory: 'header_click',
    section: 'Header',
  },
  [eventData.headerLoginSignupCtaClick]: {
    event: 'header_loginsignup_cta_click',
    eventCategory: 'header_click',
    section: 'Header',
  },
  [eventData.headerHamburgerClick]: {
    event: 'header_hamburger_click',
    eventCategory: 'header_click',
    section: 'Header',
  },
  [eventData.headerSearchClick]: {
    event: 'header_search_click',
    eventCategory: 'header_click',
    section: 'Header',
  },
  [eventData.headerCreatedematButtonClick]: {
    event: 'header_createdemat_button_click',
    eventCategory: 'header_click',
    section: 'Header',
  },
  [eventData.headerDownloadBannerClick]: {
    event: 'header_download_banner_click',
    eventCategory: 'header_click',
  },
  [eventData.headerCrossButtonClick]: {
    event: 'header_cross_button_click',
    eventCategory: 'header_click',
    section: 'Header',
  },
  [eventData.headerLoginCtaClick]: {
    event: 'header_login_cta_click',
    eventCategory: 'login',
    section: 'Header',
  },
  [eventData.headerSignupCtaClick]: {
    event: 'header_signup_cta_click',
    eventCategory: 'login',
    section: 'Header',
  },
}
